module.exports = __webpack_public_path__ + "static/media/logo-javascript.bbbb150f.svg";